import { FormData } from './IncidentsCandidate'

export const checkValidation = (formData: FormData) => {
  if (
    formData.candidate == '' ||
    formData.severity_level == '' ||
    formData.overview == ''
  ) {
    return true
  } else {
    return false
  }
}
